import { Button, Group, Icon } from '@ridi/rsg';
import { Fragment, createElement } from 'react';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */



var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var Pagination = function (props) {
    var currentPage = props.currentPage, totalPages = props.totalPages, isMobile = props.isMobile, item = props.item;
    var _a = item.el, el = _a === void 0 ? 'a' : _a, _b = item.getProps, getProps = _b === void 0 ? function (page) { return ({}); } : _b;
    var sibilingPagesRange = isMobile ? 2 : 4;
    var displayGoFirst = !isMobile && (currentPage > sibilingPagesRange + 1);
    var displayGoPrev = currentPage !== 1;
    var displayGoNext = currentPage !== totalPages;
    var start = Math.max(1, currentPage - sibilingPagesRange);
    var end = Math.min(currentPage + sibilingPagesRange, totalPages);
    var pageNumbers = Array.from({ length: end - start + 1 }, function (v, k) { return k + start; });
    if (totalPages === 1) {
        return null;
    }
    return (createElement("nav", { "aria-label": "\uD398\uC774\uC9C0 \uB0B4\uBE44\uAC8C\uC774\uC158" },
        createElement("h2", { className: "a11y indent_hidden" }, "\uD398\uC774\uC9C0 \uB0B4\uBE44\uAC8C\uC774\uC158"),
        createElement("ul", { className: "Pagination" },
            displayGoFirst && (createElement(Fragment, null,
                createElement(Button, __assign({ component: el, color: "gray", outline: true, className: "Pagination_Button", "aria-label": "\uCCAB \uD398\uC774\uC9C0" }, getProps(1)), "\uCC98\uC74C"),
                createElement("span", { className: "Pagination_Dots" },
                    createElement(Icon, { name: "dotdotdot", className: "Pagination_DeviderIcon" })))),
            displayGoPrev && (createElement(Button, __assign({ component: el, color: "gray", outline: true, className: "Pagination_Button", "aria-label": "\uC774\uC804 \uD398\uC774\uC9C0" }, getProps(currentPage - 1)),
                createElement(Icon, { name: "arrow_8_left", className: "Pagination_GoPrevIcon" }))),
            createElement(Group, { className: "Pagination_Group" }, pageNumbers.map(function (pageNumber) { return (createElement(Button, __assign({ component: el, className: "Pagination_Button", color: currentPage === pageNumber ? 'blue' : 'gray', outline: !(currentPage === pageNumber), "aria-label": pageNumber + " \uD398\uC774\uC9C0", key: pageNumber }, getProps(pageNumber)), pageNumber)); })),
            displayGoNext && (createElement(Button, __assign({ component: el, color: "gray", outline: true, className: "Pagination_Button", "aria-label": "\uB2E4\uC74C \uD398\uC774\uC9C0" }, getProps(currentPage + 1)),
                createElement(Icon, { name: "arrow_8_right", className: "Pagination_GoNextIcon" }))))));
};

export { Pagination };
//# sourceMappingURL=Pagination.js.map



// WEBPACK FOOTER //
// /static/node_modules/@ridi/rsg/components/dist/Pagination.js